module.exports = __webpack_public_path__ + "static/media/img7.ace09b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/About/img7.jpg
// module id = 118
// module chunks = 0